import React, { useEffect } from "react";
import { IMutator } from "sonobello.utilities.react";

import IUserEvent from "../../Types/IUserEvent";

export interface IComposableUserEventCreatorConfig<TData> extends IMutator<IUserEvent<unknown>> {
  eventPredicate: ((data: TData) => boolean) | null;
  eventFactory: (data: TData) => IUserEvent<unknown>;
}

export interface IComposableUserEventCreatorProps<TData> {
  eventData: TData;
}

/** A composable event creator that listens to a single input state, and emits events when the state changes. */
function ComposableUserEventCreator<TData>({
  eventData,
  eventFactory,
  eventPredicate,
  onChange
}: IComposableUserEventCreatorConfig<TData> & IComposableUserEventCreatorProps<TData>): ReturnType<React.FC> {
  useEffect(() => {
    if (!eventData || (eventPredicate && !eventPredicate(eventData))) return;
    onChange(eventFactory(eventData));
  }, [eventData]);

  return null;
}

export default ComposableUserEventCreator;
